var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HMTable',{staticClass:"mt-4 w-100",attrs:{"items":_vm.items,"fields":_vm.tableFields},scopedSlots:_vm._u([{key:"name",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(data.quiz.quiz_name)+" ")]}},{key:"status",fn:function(ref){
var data = ref.data;
return [_c('HMTag',{attrs:{"status":_vm.formatStatus(data)}},[_vm._v(" "+_vm._s(_vm.getStatus(data))+" ")])]}},{key:"created",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(_vm.formatDate(data.created))+" ")]}},{key:"action",fn:function(ref){
var data = ref.data;
return [_c('a',{staticClass:"link c-brand-color pointer",on:{"click":function($event){return _vm.viewSolvedQuiz(data)}}},[_vm._v(" "+_vm._s(_vm.$t('QUIZZES.BUTTON.VIEW_QUIZ'))+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }